import { merge, Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useActualites } from '../../../contexts/actualiteContext';
import { useDocuments } from '../../../contexts/documentContext';
import { useLotsCommerciaux } from '../../../contexts/lotCommercialContext';
import { useMessages } from '../../../contexts/messageContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import { useUser } from '../../../contexts/userContext';
import More from '../../More';
import Actualite from '../Actualites/Actualite';
import NotificationBar from './NotificationBar';

const Home = () => {

    const { actualites } = useActualites();
    const { lotCommercialActif } = useLotsCommerciaux();
    const { responsiveSize } = useResponsiveSize();

    const { totalUnreadMessages } = useMessages();
    const unreaddMessagesNotification = useMemo(
        () => {
            if (totalUnreadMessages === 1) return <Text id="txtNewMessages">Vous avez reçu <strong>{totalUnreadMessages} nouveau message</strong>.</Text>;
            else if (totalUnreadMessages > 1) return <Text id="txtNewMessages">Vous avez reçu <strong>{totalUnreadMessages} nouveaux messages</strong>.</Text>;
            else return null;
        },
        [totalUnreadMessages]
    );

    const { unreadDocuments } = useDocuments();
    const unreadDocumentsNotification = useMemo(
        () => {
            if (unreadDocuments === 1) return <Text id="txtNewDocuments"><strong>{unreadDocuments} nouveau document</strong> est à votre disposition.</Text>;
            else if (unreadDocuments > 1) return <Text id="txtNewDocuments"><strong>{unreadDocuments} nouveaux documents</strong> sont à votre disposition.</Text>;
            else return null;
        },
        [unreadDocuments]
    );

    const { user } = useUser();
    const { civilite, nom } = user;

    const navigate = useNavigate();

    const styles = useMemo(
        () => {
            let styles = {
                notifications: {
                    root: {
                        gap: 13,
                        paddingBottom: 25,
                        width: "100%",
                    }
                },
                title: {
                    root: {
                        fontFamily: "Kepler Std",
                        fontWeight: 700,
                        fontSize: 23,
                        lineHeight: "28px",
                        paddingBottom: 13,
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(styles, {
                    notifications: {
                        root: {
                            paddingBottom: 49,
                            paddingLeft: 120,
                            paddingRight: 120,
                            width: "100%",
                        }
                    },
                    title: {
                        root: {
                            fontSize: 30,
                            lineHeight: "36px",
                            paddingBottom: 26,
                        }
                    },
                });

            return styles;
        },
        [responsiveSize]
    );

    return <Stack>
        {!!civilite
            ? <Text styles={styles.title}>{civilite} {nom},<br />bienvenue sur votre espace personnel&nbsp;!</Text>
            : <Text styles={styles.title}>Bienvenue sur votre espace personnel&nbsp;!</Text>
        }
        <Stack styles={styles.notifications}>
            {!!unreaddMessagesNotification && <NotificationBar>{unreaddMessagesNotification}</NotificationBar>}
            {!!unreadDocumentsNotification && <NotificationBar>{unreadDocumentsNotification}</NotificationBar>}
        </Stack>
        {Array.isArray(actualites) && actualites.length > 0 &&
            <>
                <Text styles={styles.title}>Vos actualités</Text>
                <Actualite
                    datePublication={actualites[0].datePublication}
                    description={actualites[0].description}
                    images={actualites[0].images}
                    nomCommercial={actualites[0].nomCommercial}
                    titre={actualites[0].titre}
                    vignetteSrc={actualites[0].nationale || !lotCommercialActif.perspective
                        ? undefined
                        : `data:image/png;base64,${lotCommercialActif.perspective}`
                    }
                />
                <More label="Accéder à toutes les actualités" onClick={() => navigate("/actualites")} />
            </>
        }
    </Stack>

};

export default Home;